<template>
  <div class='product-jstx product-container product-strength-count-5'>
    <banner :data='banner'></banner>
    <div class='product-content'>
      <div class='section'>
        <strength :ourstrengths='strength'></strength>
      </div>
      <div class='section'>
        <div class='feature'>
          <h2>功能特性</h2>
          <ul>
            <li v-for='(f, i) in feature' :key='i'>
              <span>
                <img :src='require(`../../assets/product/${f.img}.png`)'/>
              </span>
              <p>{{f.name}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class='section'>
        <use-case :usecase="scene"></use-case>
      </div>
      <div class='section'>
        <why-choose></why-choose>
      </div>
      <div class='section'>
        <price></price>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '../../components/banner.vue';
import Strength from '../../components/solution/our_strengths.vue';
import UseCase from '../../components/solution/use_case.vue';
import WhyChoose from '../../components/solution/why_choose.vue';
import { CONSOLE_SITE_URL } from '../../utils/constants';
import Price from './components/price.vue';

export default {
  metaInfo: {
    title: '即时通讯-实时通信服务-马兰头医学科技',
    meta: [
      {
        name: 'keywords',
        content: '即时通讯,IM,im即时通讯,即时聊天,即时通信,融云即时通讯,融云im,即时通讯云,第三方即时通讯'
      },
      {
        name: 'description',
        content: '马兰头医学科技即时通讯SDK，协助开发者快速搭建专属内置通讯平台，实现单人、多人、群聊天，多种通信场景，支持私有化部署，保证数据安全可靠'
      },
    ]
  },
  components: {
    Banner,
    Strength,
    UseCase,
    WhyChoose,
    Price,
  },
  data() {
    return {
      banner: {
        title: 'IM即时通讯',
        desc: `<div>搭建专属通讯平台</div>
          <div>私有化快速部署，保证数据安全可靠</div>`,
        image: require('../../assets/product/06.png'),
        buttonText: '立即体验',
        buttonCallback: () => {
          window.open(CONSOLE_SITE_URL);
        }
      },
      strength: {
        title: '私有化部署，搭建专属通讯平台',
        content: [{
            title: '高可用',
            intro: '单人、多人、群聊天，多种通信场景，无人数上限',
            img: require('@/assets/product/58.png')
          },{
            title: '高保障',
            intro: '采用TCP协议，保证消息传输稳定必达，高保障消息抄送',
            img: require('@/assets/product/59.png')
          },{
            title: '高并发',
            intro: '自动弹性伸缩，轻松应对亿万级消息并发',
            img: require('@/assets/product/60.png')
          },{
            title: '安全加密',
            intro: '消息内容，数据文档通过最强加密算法进行加密，保障安全',
            img: require('@/assets/product/61.png')
          },{
            title: '私有化部署',
            intro: '提供私有云、局域内网、本地化私有化部署，保证数据安全',
            img: require('@/assets/product/62.png')
          },
        ]
      },
      feature: [
        { img: '07', name: '一对一聊天' },
        { img: '08', name: '多人聊天' },
        { img: '09', name: '聊天室' },
        { img: '10', name: '呼叫邀请' },
        { img: '11', name: '完善的消息类型' },
        { img: '12', name: '历史消息查询' },
        { img: '13', name: '离线消息' },
        { img: '14', name: '个性化定制' },
        { img: '15', name: '消息管理' },
        { img: '16', name: '消息存储' },
      ],
      scene: {
        title: '使用场景',
        content: [{
            title: '企业通信',
            subtitle: '打造企业内部专属通讯平台，员工交流数据安全可靠，悉数覆盖企业内部即时通讯、会议、直播、培训班等场景',
            img: require('@/assets/product/81.png')
          }, {
            title: '社交沟通',
            subtitle: '消息精确送达，支持亿万级消息并发',
            img: require('@/assets/product/82.png')
          }, {
            title: '在线问诊',
            subtitle: '图文结合在线问诊，打造线上的“三甲医院”',
            img: require('@/assets/product/83.png')
          }, {
            title: '在线客服',
            subtitle: '客户信息获取、会话预知、快捷回复',
            img: require('@/assets/product/84.png')
          }
        ]
      }
    }
  },
}
</script>

<style lang="less" scoped>
.feature {
  width: 910px;
  margin: 0 auto;
  h2 {
    font-size: 32px;
    font-weight: 600;
    text-align: center;
    color: #333333;
  }
  ul {
    display: flex;
    flex-wrap: wrap;
    li {
      width: 182px;
      margin-top: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      span {
        display: flex;
        width: 85px;
        height: 85px;
        background: #f6f8ff;
        border-radius: 50%;
        align-items: center;
        justify-content: center;
      }
      p {
        margin-top: 12px;
        font-size: 18px;
        font-weight: 400;
        color: #666666;
      }
    }
  }
}
</style>